import { render, staticRenderFns } from "./SuburbProfiles.vue?vue&type=template&id=47632200&scoped=true&"
import script from "./SuburbProfiles.vue?vue&type=script&lang=ts&"
export * from "./SuburbProfiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47632200",
  null
  
)

export default component.exports